const { VUE_APP_OPEN_ACCOUNT } = process.env
import { post } from '@/httpRequest/http.js'
import { getBaseUrl } from '@/utils'
// import store from '@/store/openAccount'

const baseUrl = getBaseUrl(VUE_APP_OPEN_ACCOUNT)

/** 基金开户 */
export const ApplyFundAccount = data => {
    return post(baseUrl + '/uc/v1/ClientUpdate', {
        data,
    })
}

/** 基金开户网厅 */
export const ApplyFundAccount2 = data => {
    return post(baseUrl + '/uc/v0/ClientUpdate', { data, encrypt: 0 })
}
